<h2 mat-dialog-title>Candidatos para aprovação</h2>

<mat-dialog-content>
    <ng-container *ngIf="candidatesApproval.length == 0">
        <div class="empty-content">
            <ng-container *ngIf="submiting">
                <mat-progress-spinner color="primary" mode="indeterminate" [diameter]="30"></mat-progress-spinner>
            </ng-container>
            <ng-container *ngIf="!submiting">
                <div class="mat-body-2">
                    Sem candidatos para aprovar
                </div>
            </ng-container>
        </div>
    </ng-container>
    <mat-action-list>

        <ng-container *ngFor="let candidate of candidatesApproval">
            <button mat-list-item (click)="openCandidate(candidate)">
                <mat-icon matListIcon *ngIf="candidate.avatar_profile === null">account_circle</mat-icon>
                <img [src]="mediaEndpoint + candidate.avatar_profile" matListAvatar *ngIf="candidate.avatar_profile" />

                <h3 matLine>
                    {{ candidate.firstname }} {{ candidate.lastname }}
                </h3>
                <p matLine>{{ candidate.city }}</p>

                <button (click)="approveCandidate($event, candidate, true)" mat-icon-button color="primary"
                    matTooltip="Aprovar esse candidato">
                    <mat-icon>check</mat-icon>
                </button>

                <button (click)="approveCandidate($event, candidate, false)" mat-icon-button color="accent"
                    matTooltip="Remover esse candidato">
                    <mat-icon>close</mat-icon>
                </button>
            </button>
        </ng-container>
    </mat-action-list>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close color="accent">Fechar</button>
</mat-dialog-actions>